import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-center text-info my-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BSpinner = _resolveComponent("BSpinner")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_BSpinner, { class: "align-middle mr-2" }),
    _cache[0] || (_cache[0] = _createElementVNode("strong", null, "Loading...", -1))
  ]))
}